export type TagVariant =
    | 'basicBold'
    | 'basicSubtle'
    | 'primary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'mustard'
    | 'tangerine'
    | 'lavender'
    | 'denim'
    | 'lime'
    | 'ruby';
